"use strict";

var v = require('ui-validator');
function helper(Handlebars) {
  /**
   * Format a phone number (provided as a number or string) in a standard format,
   * currently (444) 444-4444. ui-validator is used to determine if the input
   * is a valid number, otherwise the default case is to return the passed in
   * number
   *
   * TODO: Format param to change the formatting
   *
   * @return {String} formatted String that represents a phone number.
   */
  function phoneFormat(number) {
    if (!number) {
      return '';
    }
    var isValid = v.validators.validTelephone({})(number) === undefined;
    if (!isValid) {
      return number;
    }

    // Optional country-code of 1 or 2 digits, w/ or w/o + prefix, followed by 10-digit number
    var regexValidation = /^(?:\+?\d{1,2})?\s*?\(?(\d{3})\)?\s*-?(\d{3})-?(\d{4})\s*(x\d{1,4})?$/i;
    var numberParts = regexValidation.exec(number);
    var format = '(%npa) %nxx-%xxxx %ext';
    var fillTemplate = function fillTemplate(match) {
      switch (match) {
        case '%npa':
          return numberParts[1];
        case '%nxx':
          return numberParts[2];
        case '%xxxx':
          return numberParts[3];
        case '%ext':
          return numberParts[4] ? numberParts[4] : '';
        default:
          return '';
      }
    };
    return format.replace(/%\w{1,4}/g, fillTemplate).trim();
  }
  Handlebars.registerHelper('phoneFormat', phoneFormat);
  return phoneFormat;
}
module.exports = helper;
